// src/utils/stockLogo.js
import React, { useState } from 'react';

const PROVIDER_LOGOS = {
  'YIELDMAX': '/logos/yieldmax.svg',
  'VANGUARD': '/logos/vanguard.png',
  'ISHARES': '/logos/ishares.png',
  'SPDR': '/logos/spdr.svg',
  'INVESCO': '/logos/invesco.png',
  'GLOBAL': '/logos/globalx.png',
  'PROSHARES': '/logos/proshares.png',
  'WISDOMTREE': '/logos/wisdomtree.png',
  'JPMORGAN': '/logos/jpmorgan.png',
  'JPM': '/logos/jpmorgan.png',
  'SCHWAB': '/logos/Schwab.png',
  'ROUNDHILL': '/logos/roundhill.png',
  'BLACKROCK': '/logos/blackrock.png',
  'AMPLIFY': '/logos/amplify.png',
  'FIDELITY': '/logos/fidelity.png',
  'FIRST': '/logos/first-trust.png'
};

const getSymbolColor = (symbol, type = 'STOCK') => {
  // Tip bazlı sabit renkler
  const typeColors = {
    'STOCK': 'bg-blue-100 dark:bg-blue-900/30 text-blue-800 dark:text-blue-200',
    'ETF': 'bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-200',
    'FUND': 'bg-purple-100 dark:bg-purple-900/30 text-purple-800 dark:text-purple-200',
    'CURRENCY': 'bg-yellow-100 dark:bg-yellow-900/30 text-yellow-800 dark:text-yellow-200'
  };

  // Eğer tip için sabit renk varsa onu kullan
  if (typeColors[type]) {
    return typeColors[type];
  }

  // Yoksa sembol bazlı dinamik renk ata
  const colors = [
    'bg-pink-100 dark:bg-pink-900/30 text-pink-800 dark:text-pink-200',
    'bg-indigo-100 dark:bg-indigo-900/30 text-indigo-800 dark:text-indigo-200',
    'bg-orange-100 dark:bg-orange-900/30 text-orange-800 dark:text-orange-200',
    'bg-teal-100 dark:bg-teal-900/30 text-teal-800 dark:text-teal-200',
    'bg-red-100 dark:bg-red-900/30 text-red-800 dark:text-red-200',
    'bg-cyan-100 dark:bg-cyan-900/30 text-cyan-800 dark:text-cyan-200'
  ];
  
  const index = symbol
    .split('')
    .reduce((acc, char) => acc + char.charCodeAt(0), 0) % colors.length;
  
  return colors[index];
};

export const StockLogo = ({ symbol, symbolInfo, variant = "default" }) => {
  const [symbolLogoError, setSymbolLogoError] = useState(false);
  const [providerLogoError, setProviderLogoError] = useState(false);

  const sizes = {
    default: {
      container: "w-8 h-8",
      image: "h-6 w-6",
      text: "text-sm"
    },
    small: {
      container: "w-6 h-6",
      image: "h-5 w-5",
      text: "text-xs"
    }
  };

  const size = sizes[variant];

  if (!symbol) return null;

  // 1. FMP Symbol Logo denemesi - başarısız olursa provider'a geç
  if (!symbolLogoError) {
    return (
      <div className={`${size.container} rounded flex items-center justify-center bg-white dark:bg-gray-800`}>
        <img
          src={`https://images.financialmodelingprep.com/symbol/${symbol}.png`}
          alt={symbol}
          className={`${size.image} object-contain`}
          onError={(e) => {
            e.currentTarget.onerror = null; // Sonsuz döngüyü engelle
            setSymbolLogoError(true);
          }}
        />
      </div>
    );
  }

  // 2. Provider Logo denemesi - başarısız olursa fallback'e geç
  const firstWord = symbolInfo?.description?.split(' ')?.[0]?.toUpperCase();
  if (!providerLogoError && firstWord && PROVIDER_LOGOS[firstWord]) {
    return (
      <div className={`${size.container} rounded flex items-center justify-center bg-white dark:bg-gray-800`}>
        <img
          src={PROVIDER_LOGOS[firstWord]}
          alt={firstWord}
          className={`${size.image} object-contain`}
          onError={(e) => {
            e.currentTarget.onerror = null; // Sonsuz döngüyü engelle
            setProviderLogoError(true);
          }}
        />
      </div>
    );
  }

  // 3. Fallback: Sembol harfleriyle logo oluştur
  // Tip bazlı veya sembol bazlı renk kullan
  const colorClass = getSymbolColor(symbol, symbolInfo?.type);
  
  return (
    <div className={`${size.container} rounded flex items-center justify-center ${colorClass}`}>
      <span className={`${size.text} font-medium`}>
        {symbol.slice(0, 2).toUpperCase()}
      </span>
    </div>
  );
};